<!--===============================================================
# SERVIZI
================================================================-->
<div class="boxes">
	<div class="box" *ngFor="let service of services">
		<app-box (buttonClick)="openBoxAction($event)" [height]="'360px'" [element]="service"></app-box>
	</div>
</div>
